import crudActions from '@/store/crudActions'
import axios from '@/libs/axios'

const endpoint = 'monitoring'
const Actions = crudActions(endpoint)

const createOrPatch = (ctx, monitoring) => new Promise((resolve, reject) => {
  const formData = new FormData()
  formData.append('name', monitoring.name)
  formData.append('period', monitoring.period)
  formData.append('quarter', monitoring.quarter)
  formData.append('work_type', monitoring.work_type)
  formData.append('quantity_work', monitoring.quantity_work)
  if (monitoring.file_upload instanceof File) formData.append('file', monitoring.file_upload)
  if (monitoring.id) {
    axios.patch(`/${endpoint}/${monitoring.id}/`, formData)
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        console.log(error)
        reject(error)
      })
  } else {
    axios.post(`/${endpoint}/ `, formData)
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        console.log(error)
        reject(error)
      })
  }
})
Actions.create = createOrPatch
export default {
  ...Actions,
  createOrPatch,
}
